/*
 * The permissions portal-api defines in code (docs/API.md → Modules and permissions). Roles are
 * sets of these; a person's permissions are the union of their roles' — `Me.permissions`.
 */
export enum Permission {
    AdminUsers         = 'admin.users',
    AdminSettings      = 'admin.settings',
    DobavniceView      = 'dobavnice.view',
    DobavniceUpload    = 'dobavnice.upload',
    DobavniceReview    = 'dobavnice.review',
    DobavniceExport    = 'dobavnice.export',
    DobavniceCatalogs  = 'dobavnice.catalogs',
    DobavniceSettings  = 'dobavnice.settings',
    InventuraView      = 'inventura.view',
    InventuraCount     = 'inventura.count',
    InventuraManage    = 'inventura.manage',
    InventuraExport    = 'inventura.export',
    InventuraArticles  = 'inventura.articles',
    PrenosView         = 'prenos.view',
    PrenosCreate       = 'prenos.create',
    PrenosReceive      = 'prenos.receive',
    PrenosManage       = 'prenos.manage',
    UrnikiView         = 'urniki.view',
    UrnikiEdit         = 'urniki.edit',
    EracuniView        = 'eracuni.view',
    EracuniManage      = 'eracuni.manage',
}

/** The module a permission belongs to: the part before the dot. */
export const permissionModule = (permission: string): string => permission.split('.')[0] ?? permission
